import { Text } from "@/elements"
import { FragmentType, graphql, useFragment } from "@/gql"
import { JobInviteCreativeCardImagesSectionFragmentDoc } from "@/gql/graphql"
import React from "react"
import clsx from "clsx"
import type { NovaSession } from "@/types"
import { FourOrLessProjects } from "../BusinessCard/components/ImageSection/FourOrLessProjects"
import { ImageSectionCarousel } from "../BusinessCard/components/ImageSection/ImageSectionCarousel"

graphql(`
  fragment JobInviteCreativeCardImagesSection on IndividualCreative {
    ...ImageSectionCreative
    creativeWorkPortfolioProjects(first: 6, status: PUBLISHED, orderBy: "profileOrder") {
      edges {
        node {
          __typename
          id

          ...ImageSectionItem
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
      ...FourOrLessProjects
      ...ImageSectionCarousel
    }
  }
`)

interface Props {
  creative: FragmentType<typeof JobInviteCreativeCardImagesSectionFragmentDoc> | null | undefined
  type: "grid" | "list"
  showTextOverlay: boolean
  showTextUnder?: boolean
  serverSession: NovaSession | null
  entryPoint: string
  containOverflow?: boolean
  imageOpensProject?: boolean
}

export const ImageSection: React.FC<Props> = props => {
  const {
    type,
    showTextOverlay,
    showTextUnder = false,
    serverSession,
    entryPoint,
    containOverflow = true,
    imageOpensProject = false,
  } = props
  const creative = useFragment(JobInviteCreativeCardImagesSectionFragmentDoc, props.creative)
  const imageData = creative?.creativeWorkPortfolioProjects?.edges
  const isGridType = type === "grid"

  const imageWidthClass = "w-[134px]"

  const fourOrLessProjects = imageData?.length && imageData.length <= 4

  return imageData?.length === 0 ? (
    <div className={clsx(isGridType && "px-6")}>
      <div
        style={{ background: "linear-gradient(0deg, #F0E5FE 0%, rgba(240, 229, 254, 0.00) 100%)" }}
        className={clsx("flex h-[134px] w-full items-center justify-center rounded-sm")}>
        <Text variant="CTASmall" className="text-fg-3">
          No projects yet
        </Text>
      </div>
    </div>
  ) : fourOrLessProjects && containOverflow ? (
    <div className={clsx(isGridType && "px-6")}>
      <FourOrLessProjects
        projects={creative?.creativeWorkPortfolioProjects}
        type={type}
        imageHeightClass={"h-[134px]"}
        imageWidthClass={imageWidthClass}
        showTextOverlay={showTextOverlay}
      />
    </div>
  ) : (
    <ImageSectionCarousel
      creative={creative}
      creativeWorkPortfolioProjects={creative?.creativeWorkPortfolioProjects}
      imageHeightClass={"h-[134px]"}
      imageWidthClass={imageWidthClass}
      showTextOverlay={showTextOverlay}
      type={type}
      entryPoint={entryPoint}
      showTextUnder={showTextUnder}
      imageOpensProject={imageOpensProject}
      serverSession={serverSession}
    />
  )
}
